import { render, staticRenderFns } from "./BookingVehicle.vue?vue&type=template&id=ba552896&scoped=true"
import script from "./BookingVehicle.vue?vue&type=script&lang=js"
export * from "./BookingVehicle.vue?vue&type=script&lang=js"
import style0 from "./BookingVehicle.vue?vue&type=style&index=0&id=ba552896&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba552896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba552896')) {
      api.createRecord('ba552896', component.options)
    } else {
      api.reload('ba552896', component.options)
    }
    module.hot.accept("./BookingVehicle.vue?vue&type=template&id=ba552896&scoped=true", function () {
      api.rerender('ba552896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/components/BookingHeader/BookingVehicle.vue"
export default component.exports